/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_ENDPROJECT, ENDPROJECT_RECEIVED } = constants.endProjectConstants;

export default {
  REQUEST_ENDPROJECT,
  ENDPROJECT_RECEIVED,

  requestEditProfileData: payload => ({
    type: REQUEST_ENDPROJECT,
    payload
  }),
  EditProfileDataReceived: () => ({
    type: ENDPROJECT_RECEIVED
  })
};
